import { useState, useEffect } from 'react';

export function useFontLoading() {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    // Check if the browser supports the Font Loading API
    if ("fonts" in document) {
      // Create an array of font loading promises
      const fontPromises = [
        document.fonts.load("300 1em Inter"),
        document.fonts.load("400 1em Inter"),
        document.fonts.load("500 1em Inter"),
        document.fonts.load("600 1em Inter"),
        document.fonts.load("700 1em Inter")
      ];

      // Wait for all fonts to load
      Promise.all(fontPromises)
        .then(() => {
          setFontsLoaded(true);
          document.documentElement.classList.remove('fonts-loading');
          document.documentElement.classList.add('fonts-loaded');
        })
        .catch((error) => {
          console.warn('Font loading failed:', error);
          // Still mark as loaded to prevent infinite loading state
          setFontsLoaded(true);
          document.documentElement.classList.add('fonts-loaded');
        });
    } else {
      // Fallback for browsers that don't support the Font Loading API
      // Use a timeout to allow for normal font loading
      const timeoutId = setTimeout(() => {
        setFontsLoaded(true);
        document.documentElement.classList.add('fonts-loaded');
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, []);

  return fontsLoaded;
} 